import { render, staticRenderFns } from "./CltProfStat.vue?vue&type=template&id=04b54c3c&"
import script from "./CltProfStat.vue?vue&type=script&lang=js&"
export * from "./CltProfStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports